const state = {
    currentStep: 0,
    optionState: []
}
export default state
